const mediaData = [
  {
    title: '蜜桃校园系列 · 精选片段',
    duration: '24:18',
    views: '12.8万',
    tag: '校园恋爱',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20video%20thumbnail%20of%20a%20school%20rooftop%20scene%20with%20two%20anime%20characters%20in%20school%20uniforms%20sharing%20a%20tender%20moment%20under%20cherry%20blossoms%2C%20warm%20sunset%20lighting%2C%20peach%20pink%20color%20palette%2C%20romantic%20atmosphere%2C%20anime%20visual%20novel%20style&width=640&height=360&seq=media-01-school&orientation=landscape',
  },
  {
    title: '异世界召唤师 · 第一话导读',
    duration: '22:45',
    views: '9.6万',
    tag: '奇幻冒险',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20video%20thumbnail%20of%20a%20magical%20portal%20opening%20in%20a%20fantasy%20world%2C%20beautiful%20female%20character%20with%20magical%20aura%2C%20warm%20golden%20and%20coral%20lighting%2C%20epic%20atmosphere%2C%20anime%20art%20style%2C%20cinematic%20composition&width=640&height=360&seq=media-02-fantasy&orientation=landscape',
  },
  {
    title: '蜜桃少女日记 · 名场面集',
    duration: '18:32',
    views: '15.3万',
    tag: '恋爱甜宠',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20video%20thumbnail%20of%20a%20cafe%20scene%20with%20beautiful%20anime%20girls%20enjoying%20desserts%20and%20chatting%2C%20warm%20cozy%20lighting%2C%20peach%20and%20cream%20color%20palette%2C%20sweet%20atmosphere%2C%20anime%20slice%20of%20life%20art%20style&width=640&height=360&seq=media-03-diary&orientation=landscape',
  },
  {
    title: '夏日柠檬草 · 全季精华',
    duration: '26:10',
    views: '8.2万',
    tag: '治愈温情',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20video%20thumbnail%20of%20a%20beach%20sunset%20scene%20with%20anime%20characters%20walking%20along%20the%20shore%2C%20warm%20golden%20hour%20lighting%2C%20peach%20and%20coral%20sky%2C%20gentle%20waves%2C%20nostalgic%20summer%20atmosphere%2C%20anime%20art%20style&width=640&height=360&seq=media-04-summer&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精彩导视
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            蜜桃动漫在线精选片段与名场面导读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100/60 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-950/60 backdrop-blur-sm text-background-50 group-hover:bg-primary-500 transition-all">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-background-950/70 text-background-50 text-xs rounded">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}